/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request schema for attendance report. The filters combine with AND.
 * @export
 * @interface AttendanceReportRequest
 */
export interface AttendanceReportRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AttendanceReportRequest
     */
    workshop_ids?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AttendanceReportRequest
     */
    class_ids?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AttendanceReportRequest
     */
    mentor_ids?: Array<string> | null;
    /**
     * 
     * @type {Date}
     * @memberof AttendanceReportRequest
     */
    start_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AttendanceReportRequest
     */
    end_date?: Date | null;
}

/**
 * Check if a given object implements the AttendanceReportRequest interface.
 */
export function instanceOfAttendanceReportRequest(value: object): value is AttendanceReportRequest {
    return true;
}

export function AttendanceReportRequestFromJSON(json: any): AttendanceReportRequest {
    return AttendanceReportRequestFromJSONTyped(json, false);
}

export function AttendanceReportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttendanceReportRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'workshop_ids': json['workshop_ids'] == null ? undefined : json['workshop_ids'],
        'class_ids': json['class_ids'] == null ? undefined : json['class_ids'],
        'mentor_ids': json['mentor_ids'] == null ? undefined : json['mentor_ids'],
        'start_date': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'end_date': json['end_date'] == null ? undefined : (new Date(json['end_date'])),
    };
}

export function AttendanceReportRequestToJSON(json: any): AttendanceReportRequest {
    return AttendanceReportRequestToJSONTyped(json, false);
}

export function AttendanceReportRequestToJSONTyped(value?: AttendanceReportRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workshop_ids': value['workshop_ids'],
        'class_ids': value['class_ids'],
        'mentor_ids': value['mentor_ids'],
        'start_date': value['start_date'] == null ? undefined : ((value['start_date'] as any).toISOString()),
        'end_date': value['end_date'] == null ? undefined : ((value['end_date'] as any).toISOString()),
    };
}

